import { render } from "./FaultCode.vue?vue&type=template&id=518a7630"
import script from "./FaultCode.vue?vue&type=script&lang=js"
export * from "./FaultCode.vue?vue&type=script&lang=js"

import "./FaultCode.vue?vue&type=style&index=0&id=518a7630&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__